import { gql, useQuery } from '@apollo/client'
import { GetStoryQuery, GetStoryQueryVariables } from 'types/graphql'

export const storyFragment = gql`
  fragment StoryFields on Story {
    id
    title
    slug
    document
    metaDescription
    imageFullPath
    categoryIds
    categories {
      id
      name
      slug
      parentId
    }
    author {
      id
      fullName
      firstName
      lastName
      jobTitle
      avatarFullPath
      username
    }
    publishedAt
  }
`

export const getStoryQuery = gql`
  ${storyFragment}
  query GetStory($slug: String!) {
    story(slug: $slug) {
      ...StoryFields
    }
  }
`

export const useStory = (slug: string) => {
  return useQuery<GetStoryQuery, GetStoryQueryVariables>(getStoryQuery, {
    variables: {
      slug
    }
  })
}
